import { blackBoxProductsUrl, mrqtStatesUrl, countiesUrl, mortgageRateUrl, mortgageLtvUrl, CONSTANTS } from "../common/constants";
import { ELOQUA } from "../../../utilities/enums";
import HttpService from "../../../services/HttpService";
import { getEnum } from "../../../services/BlackboxService";
import { DROPDOWN_IDS } from "../common/DropdownValues";

export async function sendEmailedQuote(emailDetails: FormData): Promise<boolean> {
    try {
        return await HttpService.post(ELOQUA.URL, emailDetails, { headers: { "Content-Type": "multipart/form-data" } });
    } catch (e) {
        handleError(e);
    }
}

export async function getDetailedQuote(request: any) {
    try {
        return await HttpService.post<any[]>(blackBoxProductsUrl, request);
    } catch (e) {
        handleError(e);
    }
}

export const getLoanProductOptions = () => getEnum(DROPDOWN_IDS.LOAN_PRODUCT);

export async function getMrqtUsStates() {
    try {
        return await HttpService.get<any[]>(mrqtStatesUrl, 'mrqtUsStates');
    } catch (e) {
        handleError(e);
    }
}

export async function getCountiesByStateId(stateId: number) {
    try {
        return await HttpService.get<any[]>(`${countiesUrl}/${stateId}`, `countiesByStateId:${stateId}`);
    } catch (e) {
        handleError(e);
    }

}

export async function getFirstTimeLoanAmount(): Promise<number> {
    try {
        const loanData = await HttpService.get<any>(`${mortgageRateUrl}/${CONSTANTS.MAX_FIRST_TIME_AMOUNT_CODE}`, 'firstTimeLoanAmount');
        return loanData.loan_limit ? Number(loanData.loan_limit) : -1;
    } catch (err) {
        console.error("Failed to load first time amount limit", err);
        return -1;
    }
}

export async function getLoanLimitByStateCounty(state: string, county: string, defaultAmount): Promise<number> {
    try {
        if (!county) {
            return defaultAmount;
        }
        const loanLimitCode = `${state}-${county}`.toLowerCase().replace(/[ -]/g, '_').replace(/[^a-z_]/g, '');
        const loanData = await HttpService.get<any>(`${mortgageRateUrl}/${loanLimitCode}`, `loanLimitByStateCounty:${loanLimitCode}`);
        return loanData.loan_limit ? Number(loanData.loan_limit) : defaultAmount;
    } catch (err) {
        console.warn("Failed to load limit, using default", err);
        return defaultAmount;
    }
}

export async function getDefaultLoanLimit(): Promise<number> {
    try {
        const loanData = await HttpService.get<any>(`${mortgageRateUrl}/${CONSTANTS.DEFAULT_LOAN_AMOUNT_CODE}`, 'defaultLoanLimit');
        if (!loanData.loan_limit) {
            throw new Error(`No default loan limit found`);
        }
        return Number(loanData.loan_limit);
    } catch (err) {
        console.warn("Failed to load default loan limit", err);
    }
}

export async function getLoanMaxLTVs(): Promise<any> {
    try {
        const loanData = await HttpService.get<any>(`${mortgageLtvUrl}`, 'mortageLTVs');
        return loanData.reduce((acc, loan) => {
            if (loan.CodeName === 'default') {
                acc.default = Number(loan.max_loan_to_value);
            } else {
                acc[loan.rate_id] = Number(loan.max_loan_to_value);
            }
            return acc;
        }, {});
    } catch (err) {
        console.warn("Failed to load max LTVs for loans", err);
    }
}

const handleError = (error: any) => {
    console.error("Error " + JSON.stringify(error));
    const errorMsg = error.message;
    return errorMsg;
};
